import { footerSection } from '../../data/homeContent';
import useThemeMural from '../../hooks/useThemeMural';
import './Footer.css';

/**
 * Shared site footer (homepage mural + case studies).
 * Pass `asleep` on the home page for the night Seattle mural treatment.
 *
 * Stage mirrors the home hero mural: width-driven 16:9 canvas with the
 * same tablet/mobile height caps and object-position framing.
 */
const Footer = ({ asleep = false }) => {
  const mural = useThemeMural(asleep);

  return (
  <footer className={`footer${asleep ? ' footer--asleep' : ''}`}>
    <div className="footer__stage">
      <div className="footer__paint" aria-hidden="true">
        <img
          className="footer__mural footer__mural--day"
          src={mural.day ? footerSection.mural : undefined}
          loading="lazy"
          alt=""
          draggable={false}
        />
        <img
          className="footer__mural footer__mural--dusk"
          src={mural.dusk ? footerSection.muralDusk : undefined}
          loading="lazy"
          alt=""
          draggable={false}
        />
      </div>
      <p className="footer__credit">{footerSection.credit}</p>
    </div>
  </footer>
  );
};

export default Footer;
